import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        borrowerInsuranceMode: [
          entity?.parameters?.borrowerInsuranceMode || null,
        ],
        applicationFee: [
          !_.isNil(entity.parameters.applicationFee)
            ? entity.parameters.applicationFee
            : null,
          [Validators.required],
        ],
        smoothingFeesDuration: [
          entity.parameters.smoothingFeesDuration != null
            ? entity.parameters.smoothingFeesDuration
            : 'AUCUN',
          [Validators.required],
        ],
        commDerogCode: [
          entity.parameters.commDerogCode != null
            ? entity.parameters.commDerogCode
            : 'L20',
          [Validators.required],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    const products = _.cloneDeep(this.form.value.products);
    products.forEach(product => {
      product.parameters.smoothingFeesDuration =
        product.parameters.smoothingFeesDuration === 'AUCUN'
          ? null
          : product.parameters.smoothingFeesDuration;
    });

    return products;
  }
}
